export const DownloadIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
        <g clip-path="url(#clip0_2961_2174)">
            <path d="M5.90054 12.0031C7.0721 13.1747 8.9716 13.1747 10.1432 12.0032L10.1432 12.0031L12.2846 9.86178C12.6818 9.47809 12.6928 8.84503 12.3091 8.44778C11.9254 8.05053 11.2924 8.03953 10.8951 8.42322C10.8868 8.43125 10.8786 8.43947 10.8706 8.44778L9.01523 10.3024L8.99988 1.20312C8.99988 0.650844 8.55216 0.203125 7.99988 0.203125C7.4476 0.203125 6.99988 0.650844 6.99988 1.20312L7.01388 10.2878L5.17323 8.44713C4.77598 8.06344 4.14291 8.07444 3.75923 8.47169C3.38495 8.85922 3.38495 9.47359 3.75923 9.86112L5.90054 12.0031Z" fill="white"/>
            <path d="M15 9.86987C14.4477 9.86987 14 10.3176 14 10.8699V13.9305C13.9996 14.081 13.8778 14.2028 13.7273 14.2032H2.27266C2.12222 14.2028 2.00034 14.081 2 13.9305V10.8699C2 10.3176 1.55228 9.86987 1 9.86987C0.447719 9.86987 0 10.3176 0 10.8699V13.9305C0.00146875 15.1851 1.01812 16.2017 2.27266 16.2032H13.7273C14.9819 16.2017 15.9985 15.1851 16 13.9306V10.8699C16 10.3176 15.5523 9.86987 15 9.86987Z" fill="white"/>
        </g>     
        </svg>
    `,
      }}
    />
  );
};
